module.exports = __webpack_public_path__ + "img/icon-video.bd249137.svg";